import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { NbDialogService, NbIconLibraries } from "@nebular/theme";
import { replace, remove, clone, find } from "lodash";

import { User } from "../../@core/data/users";
import { UserService } from "../../@core/services/user.service";
import { convertTimestamp } from "../../@core/utils/convertTimestamps.service";

import Bookmark from "../../models/bookmark.model";
import Course from "../../models/course.model";
import LectureContent from "../../models/lecture-content.model";
import QnA from "../../models/qna.model";
import Quiz from "../../models/quiz.model";

import { BookmarkService } from "../../services/bookmark.service";
import { takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";
import Exercise from "../../models/exercise.model";
import Announcement from "../../models/announcement.model";

@Component({
  selector: "ngx-button-approve",
  styleUrls: ["./button-approve.component.scss"],
  templateUrl: "./button-approve.component.html",
})
export class ButtonApproveComponent implements OnInit, OnDestroy {
  private destroy$: Subject<void> = new Subject<void>();
  @Input() course? = new Course();
  @Input() lecture? = new LectureContent();
  @Input() exercise? = new Exercise();
  @Input() quiz? = new Quiz();
  @Input() qna? = new QnA();
  @Input() announcement? = new Announcement();

  @Output() onApprove: EventEmitter<any> = new EventEmitter();

  submitted = false;
  loading = false;

  bookmarked?: Bookmark = new Bookmark();
  uid = "anonymous";
  isModerator = false;
  isReviewed = false;

  mode = "";
  id = "";
  value = false;

  constructor(public userService: UserService) {}

  ngOnInit() {
    this.userService
      .getCurrentUser()
      .pipe(takeUntil(this.destroy$))
      .subscribe((user: User) => {
        if (user && user.uid != this.uid) {
          this.uid = user.uid;
          this.isModerator = user.admin || user.moderator ? true : false;
          this.initData();
        } else {
          this.uid = "anonymous";
          this.isModerator = false;
        }
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  approve(value: boolean) {
    this.value = value;

    if (this.mode && this.id && this.id != "") {
      this.loading = true;
      this.submitted = true;
      this.isReviewed = true;
      this.userService
        .approveData(this.id, this.mode, this.value)
        .pipe(takeUntil(this.destroy$))
        .subscribe((data) => {
          if (data) {
            this.onApprove.emit(this.id);
          } else {
            this.isReviewed = false;
          }
          this.submitted = false;
          this.loading = false;
        });
    }
  }

  private initData() {
    if (this.course && this.course.id) {
      this.mode = "courses";
      this.id = this.course.id;
    } else if (this.lecture && this.lecture.id) {
      this.mode = "lecture-contents";
      this.id = this.lecture.id;
    } else if (this.exercise && this.exercise.id) {
      this.mode = "exercises";
      this.id = this.exercise.id;
    } else if (this.qna && this.qna.id) {
      this.mode = "qnas";
      this.id = this.qna.id;
    } else if (this.quiz && this.quiz.id) {
      this.mode = "quizzes";
      this.id = this.quiz.id;
    } else if (this.announcement && this.announcement.id) {
      this.mode = "announcements";
      this.id = this.announcement.id;
    }
  }
}
